import { ReactComponent as Illus } from "assets/icons/buyFirstShare.svg";
import { useNavigate } from "react-router-dom";
import slugs from "navigation/slugs";
import { useState } from "react";
import { updateUserInviteCode } from "services/apis/apis";
import { ACCESS_TOKEN, getItem } from "local-storage";
import { Modal } from "components/commons";
import { usePrivy, useWallets } from "@privy-io/react-auth";
import * as ethers from "ethers";
import { ChevronDownIcon, WalletIcon } from "@heroicons/react/24/outline";
import { Dialog } from "@headlessui/react";
import { useAuth } from "contexts/authContext";
import { appConfig } from "services/blockchain";

function BuyFirstShare() {
  const navigate = useNavigate();

  const { wallets } = useWallets();
  const embeddedWallet = wallets.find(
    (wallet) => wallet.walletClientType === "privy"
  );
  const { sendTransaction } = usePrivy();
  const { updateIsBuyFirstShares } = useAuth();

  // Replace this with the text you'd like on your transaction modal
  const uiConfig = {
    header: "Buy your first Share",
    description: "Your first share is free!",
    buttonText: "Purchase",
  };

  const callContract = async () => {
    try {
      if (!embeddedWallet) return;
      // Ref: https://goerli.basescan.org/address/0x1c6aAf9F74B7c63b8C77b8a0a0ec8a1652Ebc868#code
      const abi = [
        "function initializeShares(uint256 _initialShares, uint256 _numberOfBlocks)",
      ];
      const iface = new ethers.utils.Interface(abi);
      const data = iface.encodeFunctionData("initializeShares", ["1", "1000"]); // TODO: Mock params
      const unsignedTx = {
        to: appConfig.fantechAddress,
        chainId: appConfig.chainId,
        data,
      };
      await sendTransaction(unsignedTx, uiConfig);
      updateIsBuyFirstShares("IsBuyedFirstShares");
      navigate(slugs.home);
    } catch (error) {
      console.log(
        "🚀 ~ file: BuyFirstShare.tsx:58 ~ callContract ~ error:",
        error
      );
    }
  };

  return (
    <>
      <div className="min-h-screen flex-1 flex flex-col justify-between w-full h-full p-4">
        <div className="flex flex-col gap-6">
          <Illus className="w-24" />

          <div className="flex flex-col gap-4 text-sm text-slate-300">
            <h2 className="text-2xl text-white font-normal">
              Buy your first Share
            </h2>

            <div className="flex flex-col gap-2">
              <p className="">
                On fan.tech, everyone has an exclusive fandom unlocked by their
                Shares. Shares can be bought/sold on profiles, their value
                fluctuates based on circulation.
              </p>
              <p className="">
                You will earn trading fees from Share transactions. Only your
                shareholders can access your chat room, exclusive content, and
                Livestream.
              </p>
              <p className="">
                Get started by acquiring your free initial fandom Share for your
                profile.
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-2 w-full">
          <button
            className="rounded-xl btn flex-1 bg-secondary uppercase"
            onClick={(e) => {
              e.preventDefault();
              callContract();
            }}
          >
            Buy Share for $0
          </button>
          <button
            className="rounded-xl btn btn-outline border-2 border-gray-800 uppercase"
            onClick={(e) => {
              e.preventDefault();
              updateIsBuyFirstShares("IsBuyedFirstShares");
              navigate(slugs.home);
            }}
          >
            Skip
          </button>
        </div>
      </div>
    </>
  );
}

export { BuyFirstShare as default };
